import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f33cad8a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f33cad8a')) {
      api.createRecord('f33cad8a', component.options)
    } else {
      api.reload('f33cad8a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f33cad8a&", function () {
      api.rerender('f33cad8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RvuKlSpKx80Z/JS/offershelp.vue"
export default component.exports